// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Antd from 'ant-design-vue';
import request from '@/util/request/request'
import CountryFlag from 'vue-country-flag'
import { message } from 'ant-design-vue';
import router from './router'
import store from './stores'
import i18n from '@/i18n'
import install from '@/util/install'
import App from './App'
import * as echarts from 'echarts';
// import lottie from 'vue-lottie';
// Vue.component('lottie', lottie)
import 'lib-flexible/flexible.js'
import '@/assets/iconfonts/iconfont.css'

import '@/assets/fontFamily/fontFamilys.css'
import hevueImgPreview from 'hevue-img-preview'
import eChartFn from '@/components/chart/index.js'
Vue.prototype.$eChartFn = eChartFn

import ChartPanel from '@/components/chart/index.vue'
Vue.component(ChartPanel.name, ChartPanel)
// 国旗插件
Vue.prototype.$echartss=echarts
// import 'ant-design-vue/lib/style/themes/default.less'; // 引入官方提供的 less 样式入口文件
// import 'ant-design-vue/dist/antd.less'; // 引入官方提供的 less 样式入口文件
// import '@/assets/css/antDefault.less'
import Directives from '@/util/toolClass/directives.js';
 
/**
 * 引入google地图
 */
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBO5CVKScx--FbS8nlIvKBI-bbszL0hEzI', // 此处填入谷歌地图申请的key
    libraries: ['places', 'geometry']
  }
})

Vue.use(Directives);
import Vue2OrgTree from 'vue2-org-tree'
Vue.use(Vue2OrgTree)
import './components/index'

Vue.use(install);
Vue.use(Antd);
Vue.use(hevueImgPreview)
// antd message 配置
message.config({
  top: `100px`,
});

(async () => {

  Vue.config.productionTip = false

  Vue.prototype.$request = request // 将request绑定成全局

  Vue.component('vue-country-flag', CountryFlag)

  new Vue({
    el: '#app',
    store,
    i18n,
    router,
    components: { App },
    template: '<App/>'
  })
})()



// WEBPACK FOOTER //
// ./src/main.js